export const KarpenterDashboardTemplate = `
{
  "widgetType": "Group",
  "title": {
    "dataType": "Title",
    "value": "Karpenter"
  },
  "position": {
    "x": 0,
    "y": 0,
    "w": 12,
    "h": 12
  },
  "children": [
    {
      "widgetType": "Group",
      "title": {
        "dataType": "Title",
        "value": "Summary"
      },
      "position": {
        "x": 0,
        "y": 0,
        "w": 12,
        "h": 5
      },
      "children": [
        {
          "widgetType": "Markdown",
          "content": "#### Karpenter Metrics\\n\\nKarpenter metrics are documented [here](https://karpenter.sh/docs/reference/metrics/). This dashboard relies on metrics introduced in Karpenter v1.5; depending on your installed version, some metrics may be unavailable.\\n",
          "position": {
            "x": 0,
            "y": 0,
            "w": 3,
            "h": 2
          },
          "children": []
        },
        {
          "widgetType": "Stat",
          "position": {
            "x": 3,
            "y": 0,
            "w": 3,
            "h": 1
          },
          "title": {
            "dataType": "Title",
            "value": "Nodepool%20CPU%20%25%20Limits"
          },
          "children": null,
          "variables": null,
          "type": "",
          "metricSpecifiers": [],
          "formulas": [],
          "metoroQLQueries": [
            {
              "query": "(max(karpenter_nodepools_usage{nodepool=\\"$nodepool\\", resource_type=\\"cpu\\"})) / (max(karpenter_nodepools_limit{nodepool=\\"$nodepool\\", resource_type=\\"cpu\\"})) * 100",
              "bucketSize": 0
            }
          ],
          "content": "",
          "reduceOption": "avg",
          "mappings": [
            {
              "operator": ">=",
              "value": 0,
              "color": "#2196F3",
              "type": "text"
            }
          ],
          "precision": 0,
          "fontSize": "auto",
          "columnConfigs": [
            {
              "id": "value",
              "title": {
                "dataType": "Title",
                "value": "value"
              },
              "accessor": "value",
              "header": "value",
              "hiddenByDefault": true
            }
          ],
          "unitOverride": "%"
        },
        {
          "widgetType": "Stat",
          "position": {
            "x": 6,
            "y": 0,
            "w": 3,
            "h": 1
          },
          "title": {
            "dataType": "Title",
            "value": "Cluster%20CPU%20Requested"
          },
          "children": null,
          "variables": null,
          "type": "",
          "metricSpecifiers": [],
          "formulas": [],
          "metoroQLQueries": [
            {
              "query": "(sum(karpenter_nodes_total_pod_requests{nodepool=\\"$nodepool\\", resource_type=\\"cpu\\"}))",
              "bucketSize": 0
            }
          ],
          "content": "",
          "reduceOption": "avg",
          "mappings": [
            {
              "operator": ">=",
              "value": 0,
              "color": "#2196F3",
              "type": "text"
            }
          ],
          "precision": 0,
          "fontSize": "auto",
          "columnConfigs": [
            {
              "id": "value",
              "title": {
                "dataType": "Title",
                "value": "value"
              },
              "accessor": "value",
              "header": "value",
              "hiddenByDefault": true
            }
          ],
          "unitOverride": "cores"
        },
        {
          "widgetType": "Stat",
          "position": {
            "x": 9,
            "y": 0,
            "w": 3,
            "h": 1
          },
          "title": {
            "dataType": "Title",
            "value": "Allocatable%20CPU"
          },
          "children": null,
          "variables": null,
          "type": "",
          "metricSpecifiers": [],
          "formulas": [],
          "metoroQLQueries": [
            {
              "query": "sum(karpenter_nodes_allocatable{resource_type=\\"cpu\\", nodepool=\\"$nodepool\\"})\\n",
              "bucketSize": 0
            }
          ],
          "content": "",
          "reduceOption": "avg",
          "mappings": [
            {
              "operator": ">=",
              "value": 0,
              "color": "#2196F3",
              "type": "text"
            }
          ],
          "precision": 0,
          "fontSize": "auto",
          "columnConfigs": [
            {
              "id": "value",
              "title": {
                "dataType": "Title",
                "value": "value"
              },
              "accessor": "value",
              "header": "value",
              "hiddenByDefault": true
            }
          ],
          "unitOverride": "cores"
        },
        {
          "widgetType": "Stat",
          "position": {
            "x": 3,
            "y": 1,
            "w": 3,
            "h": 1
          },
          "title": {
            "dataType": "Title",
            "value": "Nodepool%20Memory%20%25%20Limits"
          },
          "children": null,
          "variables": null,
          "type": "",
          "metricSpecifiers": [],
          "formulas": [],
          "metoroQLQueries": [
            {
              "query": "(max(karpenter_nodepools_usage{nodepool=\\"$nodepool\\", resource_type=\\"memory\\"})) / (max(karpenter_nodepools_limit{nodepool=\\"$nodepool\\", resource_type=\\"memory\\"})) * 100",
              "bucketSize": 0
            }
          ],
          "content": "",
          "reduceOption": "avg",
          "mappings": [
            {
              "operator": ">=",
              "value": 0,
              "color": "#9C27B0",
              "type": "text"
            }
          ],
          "precision": 0,
          "fontSize": "auto",
          "columnConfigs": [
            {
              "id": "value",
              "title": {
                "dataType": "Title",
                "value": "value"
              },
              "accessor": "value",
              "header": "value",
              "hiddenByDefault": true
            }
          ],
          "unitOverride": "%"
        },
        {
          "widgetType": "Stat",
          "position": {
            "x": 6,
            "y": 1,
            "w": 3,
            "h": 1
          },
          "title": {
            "dataType": "Title",
            "value": "Cluster%20Memory%20Requested"
          },
          "children": null,
          "variables": null,
          "type": "",
          "metricSpecifiers": [],
          "formulas": [],
          "metoroQLQueries": [
            {
              "query": "(sum(karpenter_nodes_total_pod_requests{resource_type=\\"memory\\", nodepool=\\"$nodepool\\"})) ",
              "bucketSize": 0
            }
          ],
          "content": "",
          "reduceOption": "avg",
          "mappings": [
            {
              "operator": ">=",
              "value": 0,
              "color": "#9C27B0",
              "type": "text"
            }
          ],
          "precision": 0,
          "fontSize": "auto",
          "columnConfigs": [
            {
              "id": "value",
              "title": {
                "dataType": "Title",
                "value": "value"
              },
              "accessor": "value",
              "header": "value",
              "hiddenByDefault": true
            }
          ],
          "unitOverride": "By"
        },
        {
          "widgetType": "Stat",
          "position": {
            "x": 9,
            "y": 1,
            "w": 3,
            "h": 1
          },
          "title": {
            "dataType": "Title",
            "value": "Allocatable%20Memory"
          },
          "children": null,
          "variables": null,
          "type": "",
          "metricSpecifiers": [],
          "formulas": [],
          "metoroQLQueries": [
            {
              "query": "(sum(karpenter_nodes_allocatable{resource_type=\\"memory\\", nodepool=\\"$nodepool\\"})) ",
              "bucketSize": 0
            }
          ],
          "content": "",
          "reduceOption": "avg",
          "mappings": [
            {
              "operator": ">=",
              "value": 0,
              "color": "#9C27B0",
              "type": "text"
            }
          ],
          "precision": 0,
          "fontSize": "auto",
          "columnConfigs": [
            {
              "id": "value",
              "title": {
                "dataType": "Title",
                "value": "value"
              },
              "accessor": "value",
              "header": "value",
              "hiddenByDefault": true
            }
          ],
          "unitOverride": "By"
        },
        {
          "widgetType": "MetricChart",
          "position": {
            "x": 0,
            "y": 2,
            "w": 4,
            "h": 2
          },
          "title": {
            "dataType": "Title",
            "value": "Node%20AZ%20Distribution"
          },
          "children": null,
          "variables": null,
          "type": "area",
          "metricSpecifiers": [],
          "formulas": [],
          "metoroQLQueries": [
            {
              "query": "count(karpenter_nodes_total_pod_requests{resource_type=\\"pods\\", nodepool=\\"$nodepool\\"}) by (zone)",
              "bucketSize": 0,
              "visualization": {
                "unit": "Nodes"
              }
            }
          ],
          "content": "",
          "reduceOption": "",
          "mappings": null,
          "precision": null,
          "fontSize": null,
          "columnConfigs": null
        },
        {
          "widgetType": "MetricChart",
          "position": {
            "x": 4,
            "y": 2,
            "w": 4,
            "h": 2
          },
          "title": {
            "dataType": "Title",
            "value": "Pod%20AZ%20Distribution"
          },
          "children": null,
          "variables": null,
          "type": "area",
          "metricSpecifiers": [],
          "formulas": [],
          "metoroQLQueries": [
            {
              "query": "sum(karpenter_pods_state{nodepool=\\"$nodepool\\"}) by (zone)",
              "bucketSize": 0,
              "visualization": {
                "unit": "Pods"
              }
            }
          ],
          "content": "",
          "reduceOption": "",
          "mappings": null,
          "precision": null,
          "fontSize": null,
          "columnConfigs": null
        },
        {
          "widgetType": "Stat",
          "position": {
            "x": 8,
            "y": 2,
            "w": 4,
            "h": 2
          },
          "title": {
            "dataType": "Title",
            "value": "Total%20number%20of%20pods"
          },
          "children": null,
          "variables": null,
          "type": "",
          "metricSpecifiers": [],
          "formulas": [],
          "metoroQLQueries": [
            {
              "query": "sum(karpenter_pods_state{nodepool=\\"$nodepool\\"})",
              "bucketSize": 0
            }
          ],
          "content": "",
          "reduceOption": "lastNotNull",
          "mappings": [
            {
              "operator": ">=",
              "value": 0,
              "color": "#FFFFFF",
              "type": "text"
            }
          ],
          "precision": 0,
          "fontSize": "auto",
          "columnConfigs": [
            {
              "id": "value",
              "title": {
                "dataType": "Title",
                "value": "value"
              },
              "accessor": "value",
              "header": "value",
              "hiddenByDefault": true
            }
          ]
        }
      ],
      "variables": []
    },
    {
      "widgetType": "Group",
      "title": {
        "dataType": "Title",
        "value": "Cluster"
      },
      "position": {
        "x": 0,
        "y": 5,
        "w": 12,
        "h": 3
      },
      "children": [
        {
          "widgetType": "Stat",
          "position": {
            "x": 0,
            "y": 0,
            "w": 2,
            "h": 2
          },
          "metricSpecifiers": [],
          "formulas": [],
          "reduceOption": "avg",
          "mappings": [
            {
              "operator": ">",
              "value": 0,
              "color": "#2196F3",
              "type": "text"
            }
          ],
          "precision": 2,
          "metoroQLQueries": [
            {
              "query": "(sum(karpenter_nodes_total_pod_requests{nodepool=\\"$nodepool\\", resource_type=\\"cpu\\"})) / sum(karpenter_nodes_allocatable{resource_type=\\"cpu\\", nodepool=\\"$nodepool\\"}) * 100",
              "bucketSize": 60
            }
          ],
          "title": {
            "dataType": "Title",
            "value": ""
          },
          "fontSize": "auto",
          "columnConfigs": [],
          "unitOverride": "% CPU Allocated"
        },
        {
          "widgetType": "MetricChart",
          "position": {
            "x": 2,
            "y": 0,
            "w": 4,
            "h": 2
          },
          "title": {
            "dataType": "Title",
            "value": "Cluster%20CPU"
          },
          "children": null,
          "variables": null,
          "type": "line",
          "metricSpecifiers": [],
          "formulas": [],
          "metoroQLQueries": [
            {
              "query": "(sum(karpenter_nodes_total_pod_requests{nodepool=\\"$nodepool\\", resource_type=\\"cpu\\"}))",
              "bucketSize": 0,
              "visualization": {
                "displayName": "Allocated"
              }
            },
            {
              "query": "sum(karpenter_nodes_allocatable{resource_type=\\"cpu\\", nodepool=\\"$nodepool\\"})",
              "bucketSize": 0,
              "visualization": {
                "displayName": "Allocatable"
              }
            },
            {
              "query": "max(karpenter_nodepools_limit{nodepool=\\"$nodepool\\", resource_type=\\"cpu\\"})",
              "bucketSize": 0,
              "visualization": {
                "displayName": "Allocatable Limits"
              }
            }
          ],
          "content": "",
          "reduceOption": "",
          "mappings": null,
          "precision": null,
          "fontSize": null,
          "columnConfigs": null
        },
        {
          "widgetType": "Stat",
          "position": {
            "x": 6,
            "y": 0,
            "w": 2,
            "h": 2
          },
          "metricSpecifiers": [],
          "formulas": [],
          "reduceOption": "avg",
          "mappings": [
            {
              "operator": ">",
              "value": 0,
              "color": "#1f99fc",
              "type": "text"
            }
          ],
          "precision": 2,
          "metoroQLQueries": [
            {
              "query": "(sum(karpenter_nodes_total_pod_requests{nodepool=\\"$nodepool\\", resource_type=\\"memory\\"})) / sum(karpenter_nodes_allocatable{nodepool=\\"$nodepool\\", resource_type=\\"memory\\"}) * 100",
              "bucketSize": 60
            }
          ],
          "title": {
            "dataType": "Title",
            "value": ""
          },
          "fontSize": "auto",
          "columnConfigs": [],
          "unitOverride": "% Memory Allocated"
        },
        {
          "widgetType": "MetricChart",
          "position": {
            "x": 8,
            "y": 0,
            "w": 4,
            "h": 2
          },
          "title": {
            "dataType": "Title",
            "value": "Cluster%20Memory"
          },
          "children": null,
          "variables": null,
          "type": "line",
          "metricSpecifiers": [],
          "formulas": [],
          "metoroQLQueries": [
            {
              "query": "(sum(karpenter_nodes_total_pod_requests{nodepool=\\"$nodepool\\", resource_type=\\"memory\\"}))",
              "bucketSize": 0,
              "visualization": {
                "displayName": "Allocated",
                "lineDotSize": 3
              }
            },
            {
              "query": "sum(karpenter_nodes_allocatable{nodepool=\\"$nodepool\\", resource_type=\\"memory\\"})",
              "bucketSize": 0,
              "visualization": {
                "displayName": "Allocatable",
                "lineDotSize": 3
              }
            },
            {
              "query": "max(karpenter_nodepools_limit{nodepool=\\"$nodepool\\", resource_type=\\"memory\\"})",
              "bucketSize": 0,
              "visualization": {
                "displayName": "Allocatable Limits",
                "lineDotSize": 3
              }
            }
          ],
          "content": "",
          "reduceOption": "",
          "mappings": null,
          "precision": null,
          "fontSize": null,
          "columnConfigs": null
        }
      ],
      "variables": []
    },
    {
      "widgetType": "Group",
      "title": {
        "dataType": "Title",
        "value": "Nodes"
      },
      "position": {
        "x": 0,
        "y": 8,
        "w": 12,
        "h": 7
      },
      "children": [
        {
          "widgetType": "MetricChart",
          "position": {
            "x": 0,
            "y": 0,
            "w": 6,
            "h": 2
          },
          "title": {
            "dataType": "Title",
            "value": "Nodes%20Created"
          },
          "children": null,
          "variables": null,
          "type": "bar",
          "metricSpecifiers": [],
          "formulas": [],
          "metoroQLQueries": [
            {
              "query": "sum(karpenter_nodes_created_total{nodepool=\\"$nodepool\\"})",
              "bucketSize": 60,
              "visualization": {}
            }
          ],
          "content": "",
          "reduceOption": "",
          "mappings": null,
          "precision": null,
          "fontSize": null,
          "columnConfigs": null
        },
        {
          "widgetType": "MetricChart",
          "position": {
            "x": 6,
            "y": 0,
            "w": 6,
            "h": 2
          },
          "title": {
            "dataType": "Title",
            "value": "Node%20AZ%20Distribution"
          },
          "children": null,
          "variables": null,
          "type": "area",
          "metricSpecifiers": [],
          "formulas": [],
          "metoroQLQueries": [
            {
              "query": "count(karpenter_nodes_total_pod_requests{nodepool=\\"$nodepool\\", resource_type=\\"pods\\"}) by (zone)",
              "bucketSize": 0,
              "visualization": {
                "unit": "Nodes"
              }
            }
          ],
          "content": "",
          "reduceOption": "",
          "mappings": null,
          "precision": null,
          "fontSize": null,
          "columnConfigs": null
        },
        {
          "widgetType": "MetricChart",
          "position": {
            "x": 0,
            "y": 2,
            "w": 6,
            "h": 2
          },
          "title": {
            "dataType": "Title",
            "value": "Node%20CPU%20%25%20Allocated"
          },
          "children": null,
          "variables": null,
          "type": "line",
          "metricSpecifiers": [],
          "formulas": [],
          "metoroQLQueries": [
            {
              "query": "(sum(karpenter_nodes_total_pod_requests{resource_type=\\"cpu\\", nodepool=\\"$nodepool\\"}))  / (sum(karpenter_nodes_allocatable{nodepool=\\"$nodepool\\", resource_type=\\"cpu\\"})) * 100",
              "bucketSize": 0,
              "visualization": {
                "unit": "%"
              }
            }
          ],
          "content": "",
          "reduceOption": "",
          "mappings": null,
          "precision": null,
          "fontSize": null,
          "columnConfigs": null
        },
        {
          "widgetType": "MetricChart",
          "position": {
            "x": 6,
            "y": 2,
            "w": 6,
            "h": 2
          },
          "title": {
            "dataType": "Title",
            "value": "Node%20Memory%20%25%20Allocated"
          },
          "children": null,
          "variables": null,
          "type": "line",
          "metricSpecifiers": [],
          "formulas": [],
          "metoroQLQueries": [
            {
              "query": "(sum(karpenter_nodes_total_pod_requests{nodepool=\\"$nodepool\\", resource_type=\\"memory\\"})) / (sum(karpenter_nodes_allocatable{nodepool=\\"$nodepool\\", resource_type=\\"memory\\"})) * 100",
              "bucketSize": 0,
              "visualization": {
                "unit": "%"
              }
            }
          ],
          "content": "",
          "reduceOption": "",
          "mappings": null,
          "precision": null,
          "fontSize": null,
          "columnConfigs": null
        },
        {
          "widgetType": "MetricChart",
          "position": {
            "x": 0,
            "y": 4,
            "w": 6,
            "h": 2
          },
          "title": {
            "dataType": "Title",
            "value": "Interruption%20Messages"
          },
          "children": null,
          "variables": null,
          "type": "bar",
          "metricSpecifiers": [],
          "formulas": [],
          "metoroQLQueries": [
            {
              "query": "sum(karpenter_interruption_received_messages_total)",
              "bucketSize": 60,
              "visualization": {
                "unit": "Messages"
              }
            }
          ],
          "content": "",
          "reduceOption": "",
          "mappings": null,
          "precision": null,
          "fontSize": null,
          "columnConfigs": null
        },
        {
          "widgetType": "MetricChart",
          "position": {
            "x": 6,
            "y": 4,
            "w": 6,
            "h": 2
          },
          "title": {
            "dataType": "Title",
            "value": "Deleted%20Interruption%20Messages"
          },
          "children": null,
          "variables": null,
          "type": "bar",
          "metricSpecifiers": [],
          "formulas": [],
          "metoroQLQueries": [
            {
              "query": "sum(karpenter_interruption_deleted_messages_total)",
              "bucketSize": 60,
              "visualization": {
                "unit": "Messages"
              }
            }
          ],
          "content": "",
          "reduceOption": "",
          "mappings": null,
          "precision": null,
          "fontSize": null,
          "columnConfigs": null
        }
      ],
      "variables": []
    },
    {
      "widgetType": "Group",
      "title": {
        "dataType": "Title",
        "value": "Pods%20by%20Application"
      },
      "position": {
        "x": 0,
        "y": 15,
        "w": 12,
        "h": 5
      },
      "children": [
        {
          "widgetType": "MetricChart",
          "position": {
            "x": 0,
            "y": 0,
            "w": 6,
            "h": 2
          },
          "title": {
            "dataType": "Title",
            "value": "Number%20of%20pods"
          },
          "children": null,
          "variables": null,
          "type": "bar",
          "metricSpecifiers": [],
          "formulas": [],
          "metoroQLQueries": [
            {
              "query": "sum(karpenter_pods_state{nodepool=\\"$nodepool\\", owner=~\\"$application.*\\"})",
              "bucketSize": 0,
              "visualization": {}
            }
          ],
          "content": "",
          "reduceOption": "",
          "mappings": null,
          "precision": null,
          "fontSize": null,
          "columnConfigs": null
        },
        {
          "widgetType": "MetricChart",
          "position": {
            "x": 6,
            "y": 0,
            "w": 6,
            "h": 2
          },
          "title": {
            "dataType": "Title",
            "value": "Pod%20AZ%20Distribution"
          },
          "children": null,
          "variables": null,
          "type": "area",
          "metricSpecifiers": [],
          "formulas": [],
          "metoroQLQueries": [
            {
              "query": "sum(karpenter_pods_state{nodepool=\\"$nodepool\\", owner=~\\"$application\\"}) by (zone)",
              "bucketSize": 0,
              "visualization": {
                "displayName": "",
                "lineDotSize": 3
              }
            }
          ],
          "content": "",
          "reduceOption": "",
          "mappings": null,
          "precision": null,
          "fontSize": null,
          "columnConfigs": null
        },
        {
          "widgetType": "MetricChart",
          "position": {
            "x": 0,
            "y": 2,
            "w": 12,
            "h": 2
          },
          "title": {
            "dataType": "Title",
            "value": "Skew%20"
          },
          "children": null,
          "variables": null,
          "type": "bar",
          "metricSpecifiers": [],
          "formulas": [],
          "metoroQLQueries": [
            {
              "query": "(max(karpenter_pods_state{nodepool=\\"$nodepool\\", owner=~\\"$application\\"})) - (min(karpenter_pods_state{nodepool=\\"$nodepool\\", owner=~\\"$application\\"}))",
              "bucketSize": 0,
              "visualization": {
                "displayName": "",
                "lineDotSize": 3
              }
            }
          ],
          "content": "",
          "reduceOption": "",
          "mappings": null,
          "precision": null,
          "fontSize": null,
          "columnConfigs": null
        }
      ],
      "variables": []
    }
  ],
  "variables": [
    {
      "name": "nodepool",
      "key": "nodepool",
      "defaultType": "metric",
      "defaultMetricName": "karpenter_nodes_allocatable",
      "defaultValue": "*",
      "isOverrideable": true
    },
    {
      "name": "application",
      "key": "owner",
      "defaultType": "metric",
      "defaultMetricName": "karpenter_pods_state",
      "defaultValue": ".*",
      "isOverrideable": true
    }
  ]
}
`